export default {
  stockLabelInStock: {
    id: 'product_page_in_stock_display',
    defaultMessage: 'In Stock',
  },
}
